const API_BASE_URL = window.location.hostname === 'localhost' ? 'http://localhost:5001/api' : 'https://xoxolite.com/xoxo/api/';

export default { API_BASE_URL };